import React, { useState } from 'react';
import Navigation from './Navigation';
import MobileMenu from './MobileMenu';

interface HeaderProps {
  currentPath?: string;
}

const Header: React.FC<HeaderProps> = ({ currentPath = '/' }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className='sticky top-0 z-50 bg-glory-blue-dark backdrop-blur-sm border-b border-glory-blue-dark/20'>
      {/* 添加细微阴影 */}
      <div className='shadow-header'>
        <div className='max-w-none mx-auto px-6 sm:px-8 lg:px-12 xl:px-16'>
          <div className='flex items-center justify-between h-20'>
            {/* Logo区域 */}
            <div className='flex-shrink-0 mr-6 lg:mr-8'>
              <a href='/' className='flex items-center gap-3 lg:gap-4 group'>
                <div className='flex items-center gap-3 lg:gap-4'>
                  {/* Logo图标 */}
                  <div className='w-12 h-12 bg-gradient-to-br from-glory-gold via-glory-gold-dark to-glory-gold rounded-xl flex items-center justify-center shadow-lg ring-2 ring-glory-gold/30'>
                    <span className='text-white font-bold text-2xl'>Elo</span>
                  </div>

                  {/* Logo文字 */}
                  <div>
                    <h1 className='bg-gradient-to-r from-glory-gold via-glory-gold-light to-glory-gold bg-clip-text text-transparent font-bold text-3xl tracking-wide group-hover:from-glory-gold-light group-hover:via-glory-gold-light group-hover:to-glory-gold-light transition-all duration-300'>
                      王者ELO
                    </h1>
                    <p className='text-gray-300 text-sm -mt-1'>
                      职业选手排名系统
                    </p>
                  </div>
                </div>
              </a>
            </div>

            {/* 桌面端导航菜单 */}
            <Navigation currentPath={currentPath} />

            {/* 工具区域 */}
            <div className='hidden md:flex items-center gap-2 lg:gap-3 ml-6 lg:ml-8'>
              {/* 搜索图标（预留） */}
              <button
                className='p-3 text-gray-300 hover:text-glory-gold-light transition-colors duration-200 rounded-lg hover:bg-white/5'
                title='搜索功能开发中'
              >
                <svg
                  className='w-6 h-6'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                  />
                </svg>
              </button>
            </div>

            {/* 移动端汉堡菜单按钮 */}
            <div className='md:hidden'>
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className='inline-flex items-center justify-center p-3 rounded-md text-glory-gold hover:text-glory-gold-light hover:bg-white/5 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-glory-gold transition-colors duration-200'
                aria-expanded='false'
              >
                <span className='sr-only'>打开主菜单</span>
                {!isMobileMenuOpen ? (
                  <svg
                    className='block h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  </svg>
                ) : (
                  <svg
                    className='block h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M6 18L18 6M6 6l12 12'
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* 移动端菜单 */}
        <MobileMenu
          currentPath={currentPath}
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      </div>
    </header>
  );
};

export default Header;
